import "../css/login.css";
import SubHeader from "./subHeader";
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { setAdminToken } from "../util/auth";
const Login = () => {
  const navigate = useNavigate();
  const [adminId, setAdminId] = useState("");
  const [adminPw, setAdminPw] = useState("");
  const [loading, setLoading] = useState(false);
  const onChangeId = (e) => {
    setAdminId(e.target.value);
  };
  const onChangePw = (e) => {
    setAdminPw(e.target.value);
  };
  // 예전엔 아이디/비밀번호를 브라우저 코드에서 "admin"/"admin"으로 직접
  // 비교했습니다. 화면 소스만 열어봐도 값이 보였고, 서버는 이 요청이
  // 정말 로그인 화면을 거쳐 왔는지 전혀 확인하지 않았습니다.
  // 이제는 서버(Railway 환경변수 ADMIN_ID/ADMIN_PW)에 실제로 물어보고,
  // 서버가 발급한 토큰(JWT)이 있어야만 그 뒤 화면과 API를 쓸 수 있습니다.
  // (세션 쿠키가 아니라 토큰인 이유는 util/auth.js 상단 설명 참고 —
  //  프론트/백엔드가 서로 다른 도메인이라 쿠키가 제3자 쿠키로 차단됐습니다)
  const submit = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const { data } = await axios.post("/admin/auth/login", {
        adminId,
        adminPw,
      });
      setAdminToken(data.token);
      navigate("/");
    } catch (error) {
      alert(
        error.response?.data?.message || "아이디 혹은 비밀번호가 틀렸습니다."
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <SubHeader />
      <div className="login">
        <p>로그인</p>
        <div className="input_box">
          <input
            type="text"
            name="admin_id"
            value={adminId}
            onChange={onChangeId}
            placeholder="아이디"
          />
          <input
            type="password"
            name="adminPw"
            value={adminPw}
            placeholder="비밀번호"
            onChange={onChangePw}
          />
        </div>
        <div className="btn" onClick={submit}>
          로그인
        </div>
      </div>
    </>
  );
};

export default Login;
